import React, { useState, useEffect, useCallback } from 'react'

const Range = ({ readOnly, onChange, ...props }) => {
  let { from, to, unit, amount, type, currency } = props
  let skipLabel = false

  const [value, setValue] = useState(amount)

  useEffect(() => {
    setValue(amount)
  }, [amount])

  const onValueChange = useCallback(({ target: { value: inputValue } }) => {
    const [abs, dec] = inputValue.toString().split('.')

    if (dec && dec.length > 2) {
      return
    }

    if (isNaN(inputValue.toString().trim().replace(',', '.'))) {
      return
    }

    setValue(inputValue.replace(',', '.'))

    if (
      inputValue.toString() !== '' &&
      !inputValue.toString().endsWith('.') &&
      !inputValue.toString().endsWith(',') 
    ) {
      onChange(parseFloat(inputValue))
    }
  }, [amount, value])

  currency = {
    EUR: '\u20AC',
    GBP: '\u00A3',
    USD: '\u0024',
    JPY: '\u00A5',
    PERCENT: '%',
  }[currency] || currency

  if (to === -1) {
    from = 'in perpetuity'
    to = null
  } else {
    from = to === -1 ? `${from} ${unit}` : from
    to = to === -1 ? 'in perpetuity' : `${to} ${unit}`
  }

  if (currency == 'PERCENT') {
    unit = null
  }

  if (currency == 'MONTHS') {
    unit = null
  }

  if (unit == 'FIXED') {
    skipLabel = true
    unit = null
  }

  if (unit == 'WORDS' && type == 'ABSOLUTE') {
    unit = null
  } else if (unit == 'WORDS') {
    unit = 'word'
  } else if (unit == 'MONTHS') {
    unit = null
  }

  const label = `${from} ${to ? ` - ${to}` : ''}`.toLowerCase()
  const suffix = `${currency} ${unit ? ` / ${unit}` : ''}`

  return (
    <React.Fragment>
      { !skipLabel &&
        <div className="py-1 align-middle px-2 font-medium text-sm text-gray-700 lowercase truncate" title={label}>
          { label }
        </div>
      }
      <div className={`py-1 align-middle px-2 ${skipLabel ? 'row-span-2' : ''}`}>
        <input
          type="text"
          className={`inline-block text-sm w-10 ${readOnly ? 'cursor-not-allowed bg-white' : 'cursor-edit bg-gray-100 pl-1 mr-1 border border-gray-300'}`}
          value={value.toString()}
          disabled={readOnly}
          onChange={onValueChange}
        />
        <span className="truncate" title={suffix}>{ suffix }</span>
      </div>
    </React.Fragment>
  )
}

export default Range
